import React from "react";
import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import {
  isSameOrBefore,
  isBefore,
  isAfter,
  DDMMYYYYFormat,
} from "app/_helpers/dateHelper";
import { Validation } from "app/_helpers/validation/Validation";
import { siteTypeObj } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";
import moment from "moment";
import { formAFields } from "../FormA/FormA.data";
import { Col } from "react-bootstrap";
// import { Col } from "react-bootstrap";

export const initialEmpToUserField = {
  roleId: "",
  siteId: "",
};

export const employeeToUserFieldRules = [
  {
    field_name: "roleId",
    label: "Role",
    type: "text",
    isRequired: true,
  },
  {
    field_name: "siteId",
    label: "Site",
    type: "text",
    isRequired: true,
  },
  {
    field_name: "classification",
    label: "Classification",
    type: "text",
    isRequired: true,
  },

  {
    field_name: "companyId",
    label: "Organization",
    type: "text",
    isRequired: true,
  },
  {
    field_name: "departmentId",
    label: "Department",
    type: "text",
    isRequired: true,
  },
  {
    field_name: "contactNumber",
    label: "Mobile Number",
    type: "text",
    isRequired: true,
  },
  {
    field_name: "designation",
    label: "Designation",
    type: "text",
    isRequired: true,
  },
];

export const initialEmployeeForm = {
  aadharNumber: "",
  firstName: "",
  middleName: "",
  lastName: "",
  email: "",
  dob: "",
  employeeId: "",
  mobileNumber: "",
  gender: "",
  employmentStatus: "active",
  dateOfJoining: "",
  dateOfSeparation: "",
  siteType: "",
  currentWorkLocation: "",
  startDateAtMines: "",
  // endDateAtMines: "",
  mineTag: "no",
  trainingEligibility: "",
  trainingDesignation: "",
  designationChangeTrainingDate: "",
  designationChangeTrainingStatus: "",
  specialMedicalExamEligibility: "",
  specialMedicalExamCategory: "",

  designation: "",
  isPmeDate: false,
  isRefresherDate: false,
  pmeCertificateNo: "",
  pmeCertificateId: null,
  isIMEDate: false,
  imeCertificateNo: "",
  imeCertificateId: null,
};

export const employeeFormLabel = {
  siteType: "Location Type",
  employeeId: "Employee ID",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  email: "Email",
  mobileNumber: "Mobile Number",
  aadharNumber: "Aadhar Number",
  dob: "Date of Birth",
  gender: "Gender",
  employmentStatus: "Employment Status",
  dateOfJoining: "Date of Joining",
  dateOfSeparation: "Date of Separation",
  currentWorkLocation: "Current Work Location",
  startDateAtMines: "Start Date at Location",
  endDateAtMines: "End Date at Mines",
  mineTag: "Mine Tag",
  trainingEligibility: "Training Eligibility",
  trainingDesignation: "Training Designation",
  designationChangeTrainingDate: "Designation Change Training Date",
  designationChangeTrainingStatus: "Designation Change Training Status",
  specialMedicalExamEligibility: "Special Medical Exam Eligibility",
  specialMedicalExamCategory: "Special Medical Exam Category",
  designation: "Designation",
  basicTrainingCompletionDate: "Basic Training Completion Date",
  lastRefresherTrainingDate: "Last Refresher Training Date",

  pmeDate: "Last PME Date",
  refresherDate: "Refresher Date",
  remark: "Remark",
  effectiveDate: "Effective Date",
  pmeCertificateNo: "PME Certificate No. (If Available)",
  pmeCertificateId: "PME Certificate",
  isIMEDate: "Is Last IME Date Available?",
  imeDate: "Last IME Date",
  imeCertificateNo: "IME Certificate No. (If Available)",
  imeCertificateId: "IME Certificate",
};

export const employeeFieldRules = [
  {
    field_name: "firstName",
    label: employeeFormLabel.firstName,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "lastName",
    label: employeeFormLabel.lastName,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "employeeId",
    label: employeeFormLabel.employeeId,
    type: "text",
    isRequired: true,
  },
  // {
  //   field_name: "email",
  //   label: employeeFormLabel.email,
  //   type: "email",
  //   isRequired: false,
  // },

  {
    field_name: "mobileNumber",
    label: employeeFormLabel.mobileNumber,
    type: "number",
    minLength: 10,
    maxLength: 10,
    isRequired: false,
  },
  {
    field_name: "aadharNumber",
    label: employeeFormLabel.aadharNumber,
    type: "number",
    minLength: 12,
    maxLength: 12,
    isRequired: false,
  },
  {
    field_name: "dob",
    label: employeeFormLabel.dob,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "gender",
    label: employeeFormLabel.gender,
    type: "text",
    isRequired: true,
  },
  // {
  //   field_name: "employmentStatus",
  //   label: employeeFormLabel.employmentStatus,
  //   type: "text",
  //   isRequired: true,
  // },
  {
    field_name: "designation",
    label: employeeFormLabel.designation,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "dateOfJoining",
    label: employeeFormLabel.dateOfJoining,
    type: "text",
    isRequired: true,
  },
  // {
  //   field_name: "dateOfSeparation",
  //   label: employeeFormLabel.dateOfSeparation,
  //   type: "text",
  //   // isRequired: true,
  // },
  {
    field_name: "siteType",
    label: employeeFormLabel.siteType,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "currentWorkLocation",
    label: employeeFormLabel.currentWorkLocation,
    type: "text",
    isRequired: false,
  },
  {
    field_name: "startDateAtMines",
    label: employeeFormLabel.startDateAtMines,
    type: "text",
    // isRequired: true,
  },
  {
    field_name: "endDateAtMines",
    label: employeeFormLabel.endDateAtMines,
    type: "text",
    // isRequired: true,
  },
  {
    field_name: "mineTag",
    label: employeeFormLabel.mineTag,
    type: "text",
    // isRequired: true,
  },
  {
    field_name: "trainingEligibility",
    label: employeeFormLabel.trainingEligibility,
    type: "text",
    isRequired: false,
  },
  {
    field_name: "trainingDesignation",
    label: employeeFormLabel.trainingDesignation,
    type: "text",
    // isRequired: false,
  },
  {
    field_name: "designationChangeTrainingDate",
    label: employeeFormLabel.designationChangeTrainingDate,
    type: "text",
    isRequired: false,
  },
  {
    field_name: "designationChangeTrainingStatus",
    label: employeeFormLabel.designationChangeTrainingStatus,
    type: "text",
    isRequired: false,
  },
  {
    field_name: "specialMedicalExamEligibility",
    label: employeeFormLabel.specialMedicalExamEligibility,
    type: "text",
    isRequired: false,
  },
  {
    field_name: "specialMedicalExamCategory",
    label: employeeFormLabel.specialMedicalExamCategory,
    type: "text",
    isRequired: false,
  },
  // {
  //   field_name: "currentWorkLocation",
  //   label: employeeFormLabel.currentWorkLocation,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "startDateAtMines",
  //   label: employeeFormLabel.startDateAtMines,
  //   type: "text",
  //   // isRequired: true,
  // },
  // {
  //   field_name: "endDateAtMines",
  //   label: employeeFormLabel.endDateAtMines,
  //   type: "text",
  //   // isRequired: true,
  // },
  // {
  //   field_name: "mineTag",
  //   label: employeeFormLabel.mineTag,
  //   type: "text",
  //   // isRequired: true,
  // },
  // {
  //   field_name: "trainingEligibility",
  //   label: employeeFormLabel.trainingEligibility,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "trainingDesignation",
  //   label: employeeFormLabel.trainingDesignation,
  //   type: "text",
  //   isRequired: true,
  // },
  // {
  //   field_name: "designationChangeTrainingDate",
  //   label: employeeFormLabel.designationChangeTrainingDate,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "designationChangeTrainingStatus",
  //   label: employeeFormLabel.designationChangeTrainingStatus,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "specialMedicalExamEligibility",
  //   label: employeeFormLabel.specialMedicalExamEligibility,
  //   type: "text",
  //   isRequired: false,
  // },
  // {
  //   field_name: "specialMedicalExamCategory",
  //   label: employeeFormLabel.specialMedicalExamCategory,
  //   type: "text",
  //   isRequired: true,
  // },
];

export const employeeGenderList = [
  { name: "Male", value: "male" },
  { name: "Female", value: "female" },
  { name: "Other", value: "other" },
];

export const employeeGenderObj = {
  male: "Male",
  female: "Female",
  other: "Other",
};

export const employeeEmploymentStatusList = [
  { name: "Active", value: "active" },
  { name: "Resigned", value: "resigned" },
  { name: "Retired", value: "retired" },
];

export const employeeEmploymentStatusObj = {
  active: "Active",
  resigned: "Resigned",
  retired: "Retired",
};

export const employeeMineTagList = [
  { name: "YES", value: "yes" },
  { name: "NO", value: "no" },
];

export const employeeMineTagObj = { yes: "YES", no: "NO" };

export const employeeTrainingEligibilityList = [
  { name: "YES", value: "yes" },
  { name: "NO", value: "no" },
];

export const employeeTrainingEligibilityObj = { yes: "YES", no: "NO" };

export const employeeTrainingDesignationList = [
  {
    label: "MINES MANAGER",
    name: "MINES MANAGER",
    value: "MINES MANAGER",
    id: "MINES MANAGER",
  },
  {
    label: "SR. MANAGER(MECHANICAL)",
    name: "SR. MANAGER(MECHANICAL)",
    value: "SR. MANAGER(MECHANICAL)",
    id: "SR. MANAGER(MECHANICAL)",
  },
  {
    label: "DY. MANAGER(MINING)",
    name: "DY. MANAGER(MINING)",
    value: "DY. MANAGER(MINING)",
    id: "DY. MANAGER(MINING)",
  },
  {
    label: "MEDICAL OFFICER",
    name: "MEDICAL OFFICER",
    value: "MEDICAL OFFICER",
    id: "MEDICAL OFFICER",
  },
  {
    label: "FOREMAN (MINING)",
    name: "FOREMAN (MINING)",
    value: "FOREMAN (MINING)",
    id: "FOREMAN (MINING)",
  },
  {
    label: "MINING MATE GR.III",
    name: "MINING MATE GR.III",
    value: "MINING MATE GR.III",
    id: "MINING MATE GR.III",
  },
];

export const employeeTrainingDesignationObj = {
  Designation1: "Designation1",
  Designation2: "Designation2",
};

export const employeeTrainingStatus = [
  { name: "Done", value: "done" },
  { name: "Not Required", value: "notRequired" },
  { name: "Overdue", value: "overdue" },
];

export const employeeTrainingStatusObj = {
  done: "Done",
  notRequired: "Not Required",
  overdue: "Overdue",
};

export const employeeMedicalEligibilityList = [
  { name: "YES", value: "yes" },
  { name: "NO", value: "no" },
];
export const employeeMedicalEligibilityObj = { yes: "YES", no: "NO" };
export const employeeUserObj = { yes: "YES", no: "NO" };

export const employeeMedicalCategoryList = [
  { name: "Canteen Worker", value: "canteenWorker" },
  { name: "Operator", value: "operator" },
  { name: "High Noise", value: "highNoise" },
];

export const EMPLOYEE_MEDICAL_CATEGORY = {
  canteenWorker: "Canteen Worker",
  operator: "Operator",
  highNoise: "High Noise",
};

export const employeeMedicalCategoryObj = {
  canteenWorker: "Canteen Worker",
  operator: "Operator",
  highNoise: "High Noise",
};

export const employeeValidation = (form) => {
  let errorObj = Validation(form, employeeFieldRules);
  // console.log("editttttt error", errorObj);
  errorObj.trainingDesignation = "";

  console.log("/**/**/form.employmentStatus", form.employmentStatus, form);
  if ("resigned" == form.employmentStatus) {
    errorObj.siteType = "";
  }
  if (!form?.mobileNumber || form?.mobileNumber != "null" || form?.mobileNumber == "")
    errorObj.mobileNumber = "";

  if (form.siteType && "resigned" != form.employmentStatus) {
    if (!form.currentWorkLocation) {
      errorObj["currentWorkLocation"] =
        employeeFormLabel["currentWorkLocation"] + " is Required.";
    }

    if (!form.startDateAtMines)
      errorObj["startDateAtMines"] =
        employeeFormLabel["startDateAtMines"] + " is Required.";
  }
  if (!form?.aadharNumber) errorObj.aadharNumber = "Aadhar Number is Required.";

  if (
    form?.mobileNumber &&
    form?.mobileNumber != "null" &&
    form?.mobileNumber != "" &&
    form?.mobileNumber?.length !== 10
  ) {
    errorObj.mobileNumber = "Mobile should be of 10 digit";
  }
  if (form?.aadharNumber && form?.aadharNumber?.length !== 12) {
    errorObj.aadharNumber = "Aadhar Number should be of 12 digit";
  }
  if (form.siteType === 3) {
    errorObj = initialTrainingValidation(errorObj, form);
    errorObj = initialMedicalValidation(errorObj, form);
  }

  if (
    form?.dateOfJoining &&
    form?.startDateAtMines &&
    isAfter(form?.dateOfJoining, form?.startDateAtMines)
  ) {
    errorObj["startDateAtMines"] =
      employeeFormLabel["startDateAtMines"] +
      " Can't Before " +
      employeeFormLabel["dateOfJoining"];
  }

  return errorObj;
};

export const initialTrainingValidation = (errorObj, form) => {
  if (form.isRefresherDate) {
    if (!form.lastRefresherTrainingDate)
      errorObj["lastRefresherTrainingDate"] =
        employeeFormLabel["lastRefresherTrainingDate"] + " is Required.";

    if (!form.trainingDesignation)
      errorObj["trainingDesignation"] =
        employeeFormLabel["trainingDesignation"] + " is Required.";
  } else {
    // if (!form.trainingEligibility)
    //   errorObj["trainingEligibility"] =
    //     employeeFormLabel["trainingEligibility"] + " is Required.";

    if (form.trainingEligibility === "yes" && !form.trainingDesignation)
      errorObj["trainingDesignation"] =
        employeeFormLabel["trainingDesignation"] + " is Required.";
  }

  return errorObj;
};

export const initialMedicalValidation = (errorObj, form) => {
  if (form?.isIMEDate) {
    if (!form?.imeDate)
      errorObj["imeDate"] = employeeFormLabel["imeDate"] + " is Required.";
  }
  if (form.isPmeDate) {
    if (!form.pmeDate)
      errorObj["pmeDate"] = employeeFormLabel["pmeDate"] + " is Required.";

    console.log("form?.pmeDate", form?.pmeDate);
    console.log("form?.dob", form?.dob);

    if (form?.pmeDate && form?.dob) {
      const age = moment().diff(form?.dob, "years");
      console.log("age", age);
      // if (age < 45) {
      //   const flag = isSameOrBefore(
      //     moment().subtract(5, "Y").format("YYYY-MM-DD"),
      //     form?.pmeDate
      //   );

      //   console.log("flag", flag);

      //   if (!flag)
      //     errorObj["pmeDate"] = employeeFormLabel["pmeDate"] + " Date With in 5 year.";
      // } else {
      //   const flag = isSameOrBefore(
      //     moment().subtract(3, "Y").format("YYYY-MM-DD"),
      //     form?.pmeDate
      //   );
      //   console.log("flag", flag);

      //   if (!flag)
      //     errorObj["pmeDate"] = employeeFormLabel["pmeDate"] + " Date With in 3 year.";
      // }

      if (
        form?.dob &&
        form?.pmeDate &&
        isBefore(form?.pmeDate, form?.dob) &&
        !errorObj["pmeDate"]
      ) {
        errorObj["pmeDate"] =
          employeeFormLabel["pmeDate"] + " Can't before " + employeeFormLabel["dob"];
      }

      // if (
      //   form?.dateOfJoining &&
      //   form?.pmeDate &&
      //   isBefore(form?.pmeDate, form?.dateOfJoining) &&
      //   !errorObj["pmeDate"]
      // ) {
      //   errorObj["pmeDate"] =
      //     employeeFormLabel["pmeDate"] +
      //     " Can't before " +
      //     employeeFormLabel["dateOfJoining"];
      // }
    }

    if (!form.specialMedicalExamEligibility)
      errorObj["specialMedicalExamEligibility"] =
        employeeFormLabel["specialMedicalExamEligibility"] + " is Required.";

    if (
      form.specialMedicalExamEligibility === "yes" &&
      !form.specialMedicalExamCategory
    ) {
      errorObj["specialMedicalExamCategory"] =
        employeeFormLabel["specialMedicalExamCategory"] + " is Required.";
    }
  } else {
    if (!form.specialMedicalExamEligibility)
      errorObj["specialMedicalExamEligibility"] =
        employeeFormLabel["specialMedicalExamEligibility"] + " is Required.";

    if (
      form.specialMedicalExamEligibility === "yes" &&
      !form.specialMedicalExamCategory
    ) {
      errorObj["specialMedicalExamCategory"] =
        employeeFormLabel["specialMedicalExamCategory"] + " is Required.";
    }
  }

  console.log("initialMedicalValidation", errorObj);

  return errorObj;
};

export const employeeExtraToChange = (name, value, siteList, form) => {
  let extraToChange = {};

  if (name === "currentWorkLocation") {
    if (
      siteList
        .filter((d) => d.siteType === 3)
        .map((d) => d.id)
        .includes(+value)
    ) {
      extraToChange.mineTag = "yes";
    } else {
      extraToChange.mineTag = "no";
      // extraToChange.startDateAtMines = "";
    }
  }

  // if (name === "specialMedicalExamCategory") {
  //   extraToChange.specialMedicalExamEligibility = "";
  // }

  if (name === "trainingEligibility" && value === "no") {
    extraToChange.trainingDesignation = "";
    // extraToChange.designationChangeTrainingDate = "";
    // extraToChange.designationChangeTrainingStatus = "";
  }

  if (name === "specialMedicalExamEligibility" && value === "no") {
    extraToChange.specialMedicalExamCategory = "";
    // extraToChange.designationChangeTrainingDate = "";
    // extraToChange.designationChangeTrainingStatus = "";
  }

  if (name === "siteType") {
    extraToChange.currentWorkLocation = "";
    extraToChange.startDateAtMines = "";
    extraToChange.endDateAtMines = "";
    extraToChange.mineTag = "no";
  }

  if (name === "isRefresherDate" && value !== form?.isRefresherDate) {
    extraToChange.trainingEligibility = "";
    extraToChange.trainingDesignation = "";
    extraToChange.lastRefresherTrainingDate = "";
  }

  if (name === "isPmeDate" && value !== form?.isPmeDate) {
    extraToChange.pmeDate = "";
    extraToChange.pmeCertificateNo = "";
    extraToChange.pmeCertificateId = null;
  }

  if (name === "isIMEDate" && value !== form?.isIMEDate) {
    extraToChange.imeDate = "";
    extraToChange.imeCertificateNo = "";
    extraToChange.imeCertificateId = null;
  }

  // if (name === "employmentStatus") {
  //   extraToChange.dateOfSeparation = "";
  // }
  return extraToChange;
};

export const siteHistoryFieldRules = [
  {
    field_name: "siteId",
    label: "Site",
    type: "text",
    isRequired: true,
  },
  {
    field_name: "startDate",
    label: "Start Date",
    type: "text",
    isRequired: true,
  },
  // {
  //   field_name: "endDate",
  //   label: "End Date",
  //   type: "text",
  //   isRequired: true,
  // },
];

export const medicalHistoryFieldRules = [
  {
    field_name: "smeCategory",
    label: employeeFormLabel["specialMedicalExamCategory"],
    type: "text",
    isRequired: true,
  },
];

export const trainingHistoryFieldRules = [
  {
    field_name: "newBasicTrainingDesignation",
    label: employeeFormLabel["trainingDesignation"],
    type: "text",
    isRequired: true,
  },
];

export const siteHistoryValidation = (form) => {
  console.log("/*/*form", form);

  let errorObj = Validation(form, siteHistoryFieldRules);

  return errorObj;
};

export const trainingHistoryValidation = (form) => {
  let errorObj = Validation(form, trainingHistoryFieldRules);
  if (!form.newTrainingEligibility)
    errorObj["newTrainingEligibility"] =
      employeeFormLabel["trainingEligibility"] + " is Required.";

  if (form?.newTrainingEligibility.toLowerCase() == "yes" && !form?.effectiveDate) {
    errorObj["effectiveDate"] = employeeFormLabel["effectiveDate"] + " is Required.";
  }

  return errorObj;
};

export const medicalHistoryValidation = (form) => {
  let errorObj = Validation(form, medicalHistoryFieldRules);

  return errorObj;
};

export const employeeFormAFields = (() => {
  const obj = {};

  Object.keys(formAFields).forEach((key) => {
    obj[key] = { ...formAFields[key] };

    obj[key].fields = formAFields[key].fields.filter(
      (f) => !f.staffType || f.staffType === "employee"
    );
  });

  return obj;
})();

export const initialEmployeeFormA = (() => {
  const obj = {};

  Object.keys(employeeFormAFields).forEach((key) => {
    employeeFormAFields[key].fields.forEach((field) => {
      if (field.name) obj[field.name] = "";
    });
  });

  obj.staffType = "employee";
  obj.mineLesseName = "Odisha Mining Corporation Limited";

  return obj;
})();

export const employeeFilterFields = [
  {
    name: "currentWorkLocation",
    title: "Current Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "locationType",
    title: "Location Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(siteTypeObj).map((k) => ({
      label: siteTypeObj[k],
      value: +k,
    })),
  },
  {
    name: "aadharNumber",
    title: "Aadhar",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "email",
    title: "Email",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "mobileNumber",
    title: "Mobile",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "employmentStatus",
    title: "Emp Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(employeeEmploymentStatusObj).map((k) => ({
      label: employeeEmploymentStatusObj[k],
      value: k,
    })),
  },
  {
    name: "dob",
    title: "DOB",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "dateOfJoining",
    title: "DOJ",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "dateOfSeparation",
    title: "Exit Date",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "startDateAtMines",
    title: "Mine Start Date",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "mineTag",
    title: "Mine Tag",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(employeeMineTagObj).map((k) => ({
      label: employeeMineTagObj[k],
      value: k,
    })),
  },
  {
    name: "designation",
    title: "Designation",
    inputType: EFormFieldInputTypes.text,
  },
  // {
  //   name: "department",
  //   title: "Department",
  //   inputType: EFormFieldInputTypes.text,
  // },
  {
    name: "trainingDesignation",
    title: "Training Designation",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "specialMedicalExamEligibility",
    title: "SME Eligibility",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(employeeMedicalEligibilityObj).map((k) => ({
      label: employeeMedicalEligibilityObj[k],
      value: k,
    })),
  },
  {
    name: "userStatus",
    title: "User",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(employeeUserObj).map((k) => ({
      label: employeeUserObj[k],
      value: employeeUserObj[k],
    })),
  },
  {
    name: "formA",
    title: "Form A",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "formAStatus",
    title: "Form A Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Completed", value: "Completed" },
      { label: "Pending", value: "Pending" },
    ],
  },
  {
    name: "trainingEligibility",
    title: "Training",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
  },
  {
    name: "lastPMEDate",
    title: "Last PME Available",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
  },
  {
    name: "lastIMEDate",
    title: "Last IME Available",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
  },
];

export const searchColumn = [
  "firstName",
  "employeeId",
  "mobileNumber",
  "email",
  "aadharNumber",
];

const employeeContractorStaffStatusObj = {
  ...employeeEmploymentStatusObj,
  inActive: "InActive",
};

export const generatedTypeObj = {
  manual: "manual",
  system: "system",
};

export const WidgetBox = ({ form }) => {
  return (
    <div className={"pb-2"}>
      <div className="card card-icon-bg mb-2 ehswidgets">
        <div className="card-body">
          <Col md={2}>
            <h5>{employeeFormLabel["employmentStatus"]}</h5>
            <p className="mb-0">
              {employeeContractorStaffStatusObj[form?.employmentStatus]}
            </p>
          </Col>
          <Col md={2}>
            <h5>{employeeFormLabel["siteType"]}</h5>
            <p className="mb-0">
              {form?.ehsSite?.siteType ? siteTypeObj[form?.ehsSite?.siteType] : ""}
            </p>
          </Col>
          <Col md={2}>
            <h5>{employeeFormLabel["currentWorkLocation"]}</h5>
            <p className="mb-0">{form?.ehsSite?.name}</p>
          </Col>
          <Col md={2}>
            <h5>{employeeFormLabel["startDateAtMines"]}</h5>
            <p className="mb-0">
              {form?.startDateAtMines ? DDMMYYYYFormat(form?.startDateAtMines) : ""}
            </p>
          </Col>

          <Col md={2}>
            <h5>{"Start Date at 1st Mine"}</h5>
            <p className="mb-0">
              {form?.startDateFirstMine
                ? DDMMYYYYFormat(form?.startDateFirstMine)
                : "Not Applicable"}
            </p>
          </Col>

          {form?.dateOfSeparation && (
            <Col md={2}>
              <h5>{"End Date"}</h5>
              <p className="mb-0">
                {form?.dateOfSeparation ? DDMMYYYYFormat(form?.dateOfSeparation) : ""}
              </p>
            </Col>
          )}
        </div>
      </div>
    </div>
  );
};

export const previousTrainingObj = {
  trainingDesignation: "",
  trainingCompletionDate: "",
  trainingExpiryDate: "",
  trainingCertificateNo: "",
  trainingCertificateId: "",
};

export const previousTrainingLabel = {
  trainingDesignation: "Training Designation",
  trainingCompletionDate: "Training Date",
  trainingExpiryDate: "Expiry Date",
  trainingCertificateNo: "Certificate No.",
  trainingCertificateId: "Certificate",
};

export const previousTrainingRules = [
  {
    field_name: "trainingDesignation",
    label: previousTrainingLabel.trainingDesignation,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "trainingCompletionDate",
    label: previousTrainingLabel.trainingCompletionDate,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "trainingExpiryDate",
    label: previousTrainingLabel.trainingExpiryDate,
    type: "text",
    isRequired: true,
  },
];

export const preTrainingValidation = (previousTraining, setPreTrainingErr) => {
  let preTrainingError = previousTraining.map((data) =>
    data.deleted ? {} : Validation(data, previousTrainingRules)
  );
  setPreTrainingErr(preTrainingError);
  let flag = 0;
  for (const errObj of preTrainingError)
    for (const key in errObj)
      if (errObj[key]) {
        flag = 1;
        break;
      }
  return flag;
};

export const fliterBtnType = {
  inActiveUnAssigned: {
    label: "InActive Unassigned",
    type: "inActiveUnAssigned",
  },
  inActiveAssigned: {
    label: "InActive Assigned",
    type: "inActiveAssigned",
  },
};
